import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import lodashCompact from 'lodash/fp/compact';

import { SCREEN_ID_CONNECT_BANK_ACCOUNT_FORM } from 'client/constants/screenIds';

import NavigatorActions from 'client/actions/Navigator';
import UtilityPartnerActions from 'client/actions/UtilityPartner';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

import UPConnectBankForm from 'client/components/UPConnectBankForm/UPConnectBankForm';

@withTransitionHook
@withScreenId(SCREEN_ID_CONNECT_BANK_ACCOUNT_FORM)
@withScrollToTop
@branch(({ match }) => ({
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
}))
@withLocationQuery
class UtilityPartnerConnectBankPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Connect Bank Account | Utility Profit',
  });

  static fetchData(match, inject) {
    return Promise.all(
      lodashCompact([
        match.params.partnerSlug &&
          UtilityPartnerActions.getBySlug(inject, {
            slug: match.params.partnerSlug,
          }),
      ]),
    );
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    locationQuery: PropTypes.object.isRequired,
    utilityPartner: PropTypes.object,
  };

  _onBack = () => {
    const { dispatch, utilityPartner } = this.props;
    dispatch(NavigatorActions.goBack, {
      defaultTo: `/utility-profit/${utilityPartner.slug}`,
    });
  };

  _onSubmit = () => {
    const { utilityPartner, locationQuery, dispatch } = this.props;
    return dispatch(UtilityPartnerActions.getBySlug, {
      slug: utilityPartner.slug,
      forceRefresh: true,
    }).then(() => {
      let redirectTo = `/utility-profit/${utilityPartner.slug}`;
      if (Object.keys(locationQuery).length) {
        redirectTo += `?${queryString.stringify(locationQuery)}`;
      }

      return dispatch(NavigatorActions.replace, {
        to: redirectTo,
      });
    });
  };

  render() {
    const { utilityPartner, dispatch, history } = this.props;

    return (
      <UPConnectBankForm
        utilityPartnerId={utilityPartner.id}
        utilityPartnerSlug={utilityPartner.slug}
        history={history}
        dispatch={dispatch}
        onBack={this._onBack}
        onSubmit={this._onSubmit}
      />
    );
  }
}

UtilityPartnerConnectBankPage.displayName = 'UtilityPartnerConnectBankPage';

export default UtilityPartnerConnectBankPage;
